import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0e394346"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "imageWrapper"
}
const _hoisted_2 = ["src"]

import { computed, ComputedRef, Ref, ref } from 'vue';

import { BrandColors } from '@/data/Branding';
import { getContrastColour } from '@/data/helpers/ColourContrastHelper';

interface Props {
  icon?: string;
  initials?: string;
  toInitialise?: string;
  color?: string;
  square?: boolean;
  large?: boolean;
}
interface Emits {
  (e: 'click', event: MouseEvent): void,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'InitialIcon',
  props: {
    icon: {},
    initials: {},
    toInitialise: {},
    color: {},
    square: { type: Boolean },
    large: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const twoInitials: Ref<boolean> = ref(false);
const imageError: Ref<boolean> = ref(false);

const iconValid: ComputedRef<boolean> = computed(() => {
  return !!(props.icon && !imageError.value);
});

const bgColor: ComputedRef<string | null> = computed(() => {
  let bgColor = null;
  if (!iconValid.value) {
    bgColor = props.color || BrandColors.GREY;
  }
  return bgColor;
});

const initialsText: ComputedRef<string> = computed(() => {
  if (props.initials) {
    return props.initials;
  }

  let initials = '?';
  if (props.toInitialise) {
    let displayName = props.toInitialise.trim();
    if (displayName) {
      const initialCodePoint: number | undefined = displayName.codePointAt(0);
      // If it starts with a non-latin character, then just use that.
      if (initialCodePoint && initialCodePoint > 192) {
        initials = String.fromCodePoint(initialCodePoint);
      } else {
        displayName = displayName.replace(/[^a-zA-Z0-9]+/gim, ' ').trim();
        if (displayName) {
          initials = displayName.substring(0, 1);
          const spaceIndex = displayName.indexOf(' ');
          if (spaceIndex > 0) {
            initials += displayName.substring(spaceIndex + 1, spaceIndex + 2);
            // TODO: avoid mutating twoInitials ref here
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            twoInitials.value = true;
          }
        }
      }
    }
  }
  return initials;
});

const initialsStyle: ComputedRef<{ 'color': string }> = computed(() => {
  const colour: string = bgColor.value ? getContrastColour(bgColor.value) : '#ffffff';
  return { color: colour };
});

const initialWrapperStyle:
ComputedRef<{ 'background-color'?: string | null; padding?: string | number; border?: string }> = computed(() => {
  return {
    'background-color': bgColor.value,
    padding: (props.icon && bgColor.value ? '0.2em' : 0),
  };
});

function imageLoadError(): void {
  imageError.value = true;
}

function handleClick(event: MouseEvent): MouseEvent {
  emit('click', event);
  return event;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["initialsRoot", { large: _ctx.large }]),
    onClick: handleClick
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["initialWrapper", { square: _ctx.square }]),
      style: _normalizeStyle(initialWrapperStyle.value)
    }, [
      (iconValid.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("img", {
              class: "initialImage",
              src: _ctx.icon,
              onError: imageLoadError
            }, null, 40, _hoisted_2)
          ]))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["initials", { 'double': twoInitials.value, square: _ctx.square }]),
            style: _normalizeStyle(initialsStyle.value)
          }, _toDisplayString(initialsText.value), 7))
    ], 6)
  ], 2))
}
}

})